import './Assets/CSS/App.css';
import './Assets/CSS/HomePage.css';
import './Assets/CSS/buttons.css';
import './Assets/CSS/Categories.css';
import LoadingScreen from './Components/LoadingScreen.js';
import Legend from './Components/Legend.js';
import { waitForElement } from './JS/Utils/GlobalFunctions.js';
import { initMainScene } from './JS/THREEJS/3DWebpage/MainScene.js';

export default function App() {

  waitForElement('.appContainer', () => {
    initMainScene();
  })

  return (
    <div className="appContainer">
      <div id="canvasEl">
        {/* How to work the place, under the coin. First of the chrome because it is the one
            control that is always there — the Skip, the magnifier and the Back all start hidden
            and only appear once there is something to skip, zoom or go back from, so this is
            what the keyboard finds first. */}
        <Legend />

        {/* The lobby's aim point. Inside #canvasEl so it centres on the canvas box,
            which is exactly where the lobby's centre raycast goes. Shown and hidden
            by LobbyWalkControls; never accepts a pointer event. */}
        <div id="reticle" className="reticle" aria-hidden="true" />

        {/* What a skipped opening move cuts through. Full-viewport black, inert: it is a
            colour and nothing else, so a click meant for the scene passes through it.
            LobbyContainer adds and removes `--black`, and this layer's own transition is
            the fade — into the black and back out of it. */}
        <div id="moveBlackout" className="moveBlackout" aria-hidden="true" />

        {/* Skip for the opening move. A real button, so the keyboard reaches it too;
            LobbyContainer shows it once the camera is travelling and takes it away at the
            home position. It sits below the blackout, which swallows it on the way in. */}
        <button id="skipMove" className="skipMove" type="button">Skip</button>

        {/* The ring zoom. Named, because a magnifier on its own does not say what it is for: the
            word reads `ZOOM` and the sign beside it is the action, not a readout of the glass —
            MainScene writes `+` while the camera can still close on the ring and `−` once it is
            there. A real button, like the Skip, and equally absent until there is a ring it could
            do something to. The sign is a sibling of the glyph rather than text inside its
            viewBox: a label is not a drawing, and type inside an SVG is the one thing here that
            would not follow the button's own font and size if either changed. */}
        <button id="ringZoom" className="ringZoom" type="button" aria-label="Zoom in on the artwork">
          <svg className="ringZoom__glass" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <circle cx="10.5" cy="10.5" r="7.5" />
            <line x1="16" y1="16" x2="21.5" y2="21.5" />
          </svg>
          <span className="ringZoom__label">ZOOM</span>
          <span className="ringZoom__sign">+</span>
        </button>

        {/* The way home, bottom left, opposite the Skip. One press per level — a card that is out
            goes back to its ring, then the planet goes back to the home view — which is the order
            Escape already takes them in. MainScene shows it for the length of a visit and takes it
            away as the camera leaves. A real button, for the same reason the Skip is: the keyboard
            reaches it, and it is what a phone has instead of an Escape key. */}
        <button id="backHome" className="backHome" type="button">Back</button>
      </div>
      <div id='pagesContainer'>

      </div>
      <LoadingScreen />
    </div>
  );
}
